export default "__VITE_ASSET__yXJJYjyl__"